// import React from 'react';
// import "./index.css";
// import Home from './routes/Home';
// import About from './routes/About';
// import Project from './routes/Project';
// import Contact from './routes/Contact';
// import { Route,Routes,useLocation } from 'react-router-dom';


// function App() {
//   const location=useLocation();
//   return (
// <>
// <Routes>
//   <Route path="/" element={<Home />}/> 
//   <Route path="/project" element={<Project />}/> 
//   <Route path="/about" element={<About />}/> 
//   <Route path="/contact" element={<Contact />}/> 
// </Routes>
// </>
//   );
// }

// export default App;

import React from 'react'
import './App.css';
import Animated from './components/Animated.js';
const App = () => {
  return (
  <Animated />

  )
}

export default App;
